import Cookies from 'js-cookie';

export const getCookie = (key: string): string | undefined => {
  return Cookies.get(key);
};

export const setCookie = (key: string, data: string, expireDays: number = 7): void => {
  Cookies.set(key, data, {
    secure: false,
    expires: expireDays,
    domain: `.${import.meta.env.VITE_REACT_APP_DOMAIN}`
  });
};

export const removeCookie = (key: string, withDomain: boolean = false): void => {
  if (withDomain)
    Cookies.remove(key, {
      path: '/',
      domain: `.${import.meta.env.VITE_REACT_APP_DOMAIN}`
    });
  else Cookies.remove(key);
};

